import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ResizeBackgroundImportState } from "../types";

export const extraReducers = (builder: ActionReducerMapBuilder<ResizeBackgroundImportState>) => {};
